<div class="global-overlay-page">

  <div style="display: flex; justify-content: center;padding:20px;">
    <div style="width:100%;">

      <div class="menu">
        <input #filterInput type="text" (keyup)="filter($event)" [value]="templateFilter"
          placeholder="Filter templates" />
        <div class="toolbar">
          <a (click)="newTemplate()">New Template</a>
        </div>
      </div>

      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>
        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Code</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.code}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.description}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="content">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a class="edit-content-btn" (click)="loadContent(element.id)" title="Edit content">
              <mat-icon class="column-icon">edit</mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <div style="display: flex; justify-content: center;">
        <mat-paginator [length]="count" [pageSize]="10" (page)="onPaginateChange($event)" showFirstLastButtons
          hidePageSize="true">
        </mat-paginator>
      </div>

    </div>
  </div>

  <!-- Modal Overlay for Template Detail -->
  @if (code) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-code-detail [code]="code" (close)="closeCodeDetail($event)"></app-code-detail>
    </div>
  </div>
  }

</div>
